// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"425":"009126bc","426":"e4ad8cdb","486":"b7f2a1ca","638":"824c7c62","910":"d868a7dc"}[chunkId] + ".chunk.css";
};